module.exports = __webpack_public_path__ + "static/img/1-5.f99f740.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1-5.png
// module id = Ur9o
// module chunks = 0